import {Component, OnInit} from '@angular/core';
import {Perfil} from "../../models/perfil";
import {LoginService} from "../../services/login.service";
import {Login} from "../../models/login";
import {Router} from "@angular/router";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    private login: Login;

    constructor(private loginService: LoginService, private router: Router) {

    }

    ngOnInit() {
        this.login = this.loginService.getAuth();
		let url: string = "/login";
		if(this.login){
		    if(this.login.perfil == Perfil.GESTOR){
				url = "/planos";
            }else if(this.login.perfil == Perfil.ADMINISTRADOR){
				url = "/gerencial";
			}
		}
		this.router.navigateByUrl(url);
    }

}
